import confetti from './confettiInstancia';

// Comemoração de "voto registrado" — vários estouros de confete saindo de
// pontos diferentes da tela, espaçados por um instante cada (não um estouro
// só e nem um de origem fixa como o Confetti.js de ComoFunciona.js, que
// nasce de um elemento âncora específico). Mesmo pacote canvas-confetti já
// usado no resto do site.
const ORIGENS = [
  { x: 0.15, y: 0.25 },
  { x: 0.85, y: 0.25 },
  { x: 0.5, y: 0.15 },
  { x: 0.3, y: 0.45 },
  { x: 0.7, y: 0.45 }
];

export function celebrarVoto() {
  ORIGENS.forEach((origin, indice) => {
    setTimeout(() => {
      confetti({
        particleCount: 80,
        spread: 100,
        startVelocity: 40,
        origin,
        zIndex: 9999
      });
    }, indice * 150);
  });
}
